import { Brick, registerBrick } from 'olympe';
//import Papa from 'papaparse';

export default class DQ_JDRCSVToJSON extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} csv
     * @param {function()} forwardEvent
     * @param {function(*)} setResult
     */
    async update($, [csv], [forwardEvent, setResult]) {


        /*const startMemoryUsage0 = process.memoryUsage().heapUsed;

        // Papaparse
        let parsedContent = Papa.parse(csv);
        let headers0 = parsedContent.data[0];
    
        let jsonContent = [];
        for(let i=1;i<parsedContent.data.length;i++){
            let line = parsedContent.data[i];
            let obj = {};
            for(var j=0;j<headers0.length;j++){
                obj[headers0[j]] = line[j];
            }
        }

        const endMemoryUsage0 = process.memoryUsage().heapUsed;
        console.log('Memory used: ',endMemoryUsage0 - startMemoryUsage0);

        await new Promise(resolve => setTimeout(resolve, 3000));*/
        const startMemoryUsage = process.memoryUsage().heapUsed;
        //console.log('Old:', endMemoryUsage0, 'New: ', startMemoryUsage);
        

        // This assumes that the separator is never found within quotes
        const sep = ";"
        var lines = csv.split("\r\n");

        var result = [];
        var headers=lines[0].split(sep);
      
        for (var i=1;i<lines.length;i++){
            if (lines[i].length === 0) // skip empty lines
                continue

            var obj = {};
            var currentline=lines[i].split(sep);

            for (var j=0;j<headers.length;j++){
                // Remove "
                const value = currentline[j].replace(/\"/g, "");
                obj[headers[j]] = value;
            }

            result.push(obj);
        }

        const endMemoryUsage = process.memoryUsage().heapUsed;
        console.log('Memory used: ',endMemoryUsage - startMemoryUsage);

        setResult(result);
        forwardEvent();
    }
}

registerBrick('0185109a806f0837654f', DQ_JDRCSVToJSON);
